import defaultEmbeddableMixin from "@/mixins/embeddable/resource/defaultEmbeddableMixin";

export default {

    mixins: [defaultEmbeddableMixin],
    data() {
        return {
            yesOrNotOptions: [{value: "Y", text: this.t('yes')}, {value: "N", text: this.t('no')}],
        }
    }
}